"use client";

import React, { useCallback, useState } from "react";
import {
  Grid,
  Card,
  Box,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  TextField,
  Button,
  Select,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { getAllEventApi, getAllVenueApi } from "../../../redux/api/api";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CustomEditor from "./CustomEditor";
import FileUpload from "../../Forms/FileUpload";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { updateEventApi } from "../../../redux/api/api";
import dayjs from "dayjs";
import { Country, State, City } from 'country-state-city';

const EditAnEventForm = () => {
  const [days, setDays] = useState([{ day: "Day 1", fee: "" }]);

  const [ticketType, setTicketType] = useState("");
  const [eventType, setEventType] = useState("");
  const [selectTopic, setSelectTopic] = useState("");
  const [eventCountry, setEventCountry] = useState("");
  const [eventState, setEventState] = useState("");
  const [eventCity, setEventCity] = useState("");
  const [eventTime, setEventTime] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [venue, setVenue] = useState([]);
  const [category, setCategory] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [event, setEvent] = useState([])

  const { id } = useParams();
  //console.log(id);
  const [formData, setFormData] = useState({
    name: "",
    ticketType: "free",
    ticketPrice: "",
    eventType: "solo",
    feeStructure: "same",
    days: [{ day: "Day 1", fee: "" }],
    country: "",
    city: "",
    state: "",
    category: "",
    categoryid: "",
    venueid: "",
    countryid: "",
    stateid: "",
    city: "",

    startDate: null,
    endDate: null,
    startTime: "",
    endTime: "",
    // registrationStart: null,
    // registrationEnd: null,
    organizers: "",
    sponsors: "",
    maxbooking: "",
    description: "",
    image: null,
  });

  // console.log("Form   Data:", formData);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({ ...prev, [name]: value }));
  // };
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value, // this will set categoryid = selected _id
    });
  };
  const handleDayChange = (index, field, value) => {
    const updatedDays = [...days];
    updatedDays[index][field] = value;
    setDays(updatedDays);
  };

  const handleTicketTypeChange = (event) => {
    setTicketType(event.target.value);
  };

  const handleEventTypeChange = (event) => {
    setEventType(event.target.value);
  };
  const removeDay = (index) => {
    const newDays = [...days];
    newDays.splice(index, 1);
    setDays(newDays);
  };
  const addDay = () => {
    setDays([...days, { day: `Day ${days.length + 1}`, fee: "" }]);
  };

  const handleDateChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value ? dayjs(value) : null,  // always store as dayjs
    }));
  };


  // updateEventApi


  const fetchEventById = async (eventId) => {
    try {
      setIsLoading(true);
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/app/event/event/${eventId}`
      );
      if (!res.ok) throw new Error("Failed to fetch event");
      const data = await res.json();

     //console.log("Event data:", data.info.event);

      setFormData((prev) => ({
        ...prev,
        name: data.info.event.name || "",
        ticketType: data.info.event.ticketType || "Free",
        city: data.info.event.city || "",
        country: data.info.event.country || "",
        state: data.info.event.state || "",
        ticketPrice: data.info.event.ticketPrice || 0,
        categoryid: data.info.event.categoryid?._id || "",
        description: data.info.event.description || "",
        venueid: data.info.event.venueid?._id || "",
        cityid: data.info.event.cityid?._id || "",
        stateid: data.info.event.stateid?._id || "",
        countryid: data.info.event.countryid || "",
        startDate: data.info.event.startDate
          ? dayjs(data.info.event.startDate)
          : null,
        endDate: data.info.event.endDate
          ? new Date(data.info.event.endDate)
          : null,
        startTime: data.info.event.startTime || "",
        endTime: data.info.event.endTime || "",
        booking: data.info.event.booking || false,
        maxbooking: data.info.event.maxbooking || 0,
        isFeatured: data.info.event.isFeatured || false,
        registrationEnd: data.info.event.registrationEnd,
        registrationStart: data.info.event.registrationStart,
        status: data.info.event.status ?? true,
      }));
    } catch (error) {
      console.error("Failed to fetch event:", error);
      alert(error?.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };


  // call on mount
  useEffect(() => {
    if (id) fetchEventById(id);
  }, [id]);

  const handleVenueChange = (e) => {
    const venueId = e.target.value;
    // console.log("Selected venue ID:", venueId);
    const stateId = formData.stateid; // get current stateid from formData
    const selectedVenue = venue.find((v) => v.id === venueId);
    setFormData((prev) => ({
      ...prev,
      venueid: venueId,
      cityid: selectedVenue?.cityid || "",
      stateid: stateId || "",
      countryid: selectedVenue?.countryid || "" // if provided
    }));
  };
  const getAllVenue = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await getAllVenueApi();
      if (res.status === 200) {
        setVenue(res.data.info);
      }
    } catch (error) {
      console.error(error);
      alert("Failed to fetch venues");
    } finally {
      setIsLoading(false);
    }
  }, []);
  useEffect(() => {
    getCategory()
    getAllVenue()
    getAllEvent()
  }, [])

  const getCategory = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/category/allcategories`);
      // console.log("raw response:", response);

      if (response.status === 200) {
        const data = await response.json(); // Parse JSON
        // console.log("parsed data:", data);
        setCategory(data.info);
      }
    } catch (error) {
      alert(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const getAllEvent = async () => {
    setIsLoading(true)
    try {
      const res = await getAllEventApi()
      if (res.status === 200) {
        setEvent(res.data.info)
      }
    } catch (error) {
      console.error(error)
      alert(error?.response?.data?.message || 'Something went wrong')
    }
    setIsLoading(false)
  }


  const handleSubmit = async (e, status) => {
    e.preventDefault();
    try {
      // Prepare the payload
      const payload = new FormData();

      // Make a copy of formData and set the current status
      const updatedForm = { ...formData, status };

      Object.keys(updatedForm).forEach((key) => {
        const value = updatedForm[key];

        if (value instanceof File) {
          payload.append(key, value);
        } else if (dayjs.isDayjs(value)) {
          payload.append(key, value.format("YYYY-MM-DD"));
        } else if (Array.isArray(value)) {
          // For arrays like days, convert to JSON string
          payload.append(key, JSON.stringify(value));
        } else {
          payload.append(key, value);
        }
      });

     //console.log("Payload entries:", [...payload.entries()]);
      payload.append("id", id);
      // console.log("Payload:", payload);
      // return
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/admin/event/addevent`,
        {
          method: "POST",
          body: payload,
        }
      );

      const data = await response.json();

      if (response.ok) {
        alert("Event created successfully!");

        // Reset form
        setFormData({
          name: "",
          ticketType: "free",
          ticketPrice: "",
          eventType: "solo",
          feeStructure: "same",
          days: [{ day: "Day 1", fee: "" }],
          categoryid: "",
          venueid: "",
          countryid: "",
          stateid: "",
          city: "",
          startDate: null,
          endDate: null,
          startTime: "",
          endTime: "",
          organizers: "",
          sponsors: "",
          maxbooking: "",
          description: "",
          image: null,
        });

        setDays([{ day: "Day 1", fee: "" }]); // reset days if separate
        setTicketType("free");
        setEventType("solo");
      } else {
        alert(data.message || "Failed to save event");
      }
    } catch (error) {
      console.error("Error while saving event:", error);
      alert("Error while saving event");
    }
  };


  return (
    <>
      <Box component="form" >
        <Card
          sx={{
            boxShadow: "none",
            borderRadius: "7px",
            mb: "25px",
            padding: { xs: "18px", sm: "20px", lg: "25px" },
          }}
          className="rmui-card"
        >
          <Grid
            container
            spacing={3}
            columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 3 }}
          >
            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 4 }}>
              <Box>
                <FormControl fullWidth>
                  <Typography
                    component="label"
                    sx={{
                      fontWeight: "500",
                      fontSize: "14px",
                      mb: "10px",
                      display: "block",
                    }}
                    className="text-black"
                  >
                    Event Name
                  </Typography>

                  <TextField
                    label="Enter event name"
                    placeholder="E.g. Annual Conference 2024"
                    variant="filled"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    sx={{
                      "& .MuiInputBase-root": {
                        border: "1px solid #D5D9E2",
                        backgroundColor: "#fff",
                        borderRadius: "7px",
                      },
                      "& .MuiInputBase-root::before": {
                        border: "none",
                      },
                      "& .MuiInputBase-root:hover::before": {
                        border: "none",
                      },
                      "& .MuiInputBase-root:hover:hover:not(.Mui-disabled, .Mui-error)::before":
                      {
                        border: "none",
                      },
                    }}
                  />
                </FormControl>
              </Box>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 4 }}>
              <Box>
                <Typography
                  component="label"
                  sx={{
                    fontWeight: "500",
                    fontSize: "14px",
                    mb: "10px",
                    display: "block",
                  }}
                  className="text-black"
                >
                  Event Type
                </Typography>

                <FormControl fullWidth>

                  <Select
                    labelId="event-type-label"
                    name="eventType"
                    value={formData.eventType}
                    onChange={handleChange}
                  >
                    <MenuItem value="solo">Solo</MenuItem>
                    <MenuItem value="mega">Mega</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Grid>



            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 4 }}>
              <Box>
                <Typography
                  component="label"
                  sx={{
                    fontWeight: "500",
                    fontSize: "14px",
                    mb: "10px",
                    display: "block",
                  }}
                  className="text-black"
                >
                  Ticket Type
                </Typography>

                <FormControl fullWidth>
                  <InputLabel id="ticket-type-label">Select</InputLabel>
                  <Select
                    labelId="ticket-type-label"
                    id="product-type"
                    value={formData.ticketType}
                    onChange={handleChange}
                    label="Select"
                    name="ticketType"
                    sx={{
                      "& fieldset": {
                        border: "1px solid #D5D9E2",
                        borderRadius: "7px",
                      },
                    }}
                  >
                    <MenuItem value="Free">Free</MenuItem>
                    <MenuItem value="paid">Paid</MenuItem>

                  </Select>
                </FormControl>
              </Box>
            </Grid>

            {formData.ticketType === 1 && (
              <>
                {formData.eventType === "mega" ? (
                  <>
                    <FormControl component="fieldset" sx={{ mb: 2 }}>
                      <Typography
                        component="label"
                        sx={{
                          fontWeight: "500",
                          fontSize: "14px",
                          mb: "10px",
                          display: "block",
                        }}
                        className="text-black"
                      >
                        Fee Structure
                      </Typography>

                      <RadioGroup
                        row
                        name="feeStructure"
                        value={formData.feeStructure}
                        onChange={handleChange}
                      >
                        <FormControlLabel
                          value="same"
                          control={<Radio />}
                          label="Same Fee for All Days"
                        />
                        <FormControlLabel
                          value="different"
                          control={<Radio />}
                          label="Different Fee Per Day"
                        />
                      </RadioGroup>
                    </FormControl>

                    {formData.feeStructure === "same" && (
                      <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 4 }}>
                        <Box>
                          <FormControl fullWidth>
                            <Typography
                              component="label"
                              sx={{
                                fontWeight: "500",
                                fontSize: "14px",
                                mb: "10px",
                                display: "block",
                              }}
                              className="text-black"
                            >
                              Ticket Price
                            </Typography>

                            <TextField
                              label="Enter ticket price"
                              placeholder="E.g. $20.00"
                              variant="filled"
                              id="ticketPrice"
                              name="ticketPrice"
                              value={formData.ticketPrice}
                              onChange={handleChange}
                              sx={{
                                "& .MuiInputBase-root": {
                                  border: "1px solid #D5D9E2",
                                  backgroundColor: "#fff",
                                  borderRadius: "7px",
                                },
                                "& .MuiInputBase-root::before": { border: "none" },
                                "& .MuiInputBase-root:hover::before": { border: "none" },
                              }}
                            />
                          </FormControl>
                        </Box>
                      </Grid>
                    )}


                    {formData.feeStructure === "different" && (
                      <Grid size={{ xs: 12 }}>
                        <Box>
                          {days.map((d, index) => (
                            <Grid
                              container
                              spacing={2}
                              key={index}
                              alignItems="center"
                              sx={{ mb: 2 }}
                            >
                              {/* Day field (smaller width) */}
                              <Grid item xs={4} sm={3}>
                                <TextField
                                  fullWidth
                                  label="Day"
                                  value={d.day}
                                  onChange={(e) => handleDayChange(index, "day", e.target.value)}
                                />
                              </Grid>

                              {/* Fee field (medium width) */}
                              <Grid item xs={4} sm={3}>
                                <TextField
                                  fullWidth
                                  label="Fee"
                                  value={d.fee}
                                  onChange={(e) => handleDayChange(index, "fee", e.target.value)}
                                />
                              </Grid>

                              {/* Remove button (smaller) */}
                              <Grid item xs={4} sm={2}>
                                <Button
                                  variant="outlined"
                                  color="error"
                                  onClick={() => removeDay(index)}
                                  sx={{ whiteSpace: "nowrap" }}
                                >
                                  Remove
                                </Button>
                              </Grid>
                            </Grid>
                          ))}

                          <Button variant="contained" onClick={addDay}>
                            + Add Day
                          </Button>
                        </Box>
                      </Grid>
                    )}


                  </>
                ) : (
                  // Solo Event (only one Ticket Price)
                  <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 4 }}>
                    <Box>
                      <FormControl fullWidth>
                        <Typography
                          component="label"
                          sx={{
                            fontWeight: "500",
                            fontSize: "14px",
                            mb: "10px",
                            display: "block",
                          }}
                          className="text-black"
                        >
                          Ticket Price
                        </Typography>

                        <TextField
                          label="Enter ticket price"
                          placeholder="E.g. $20.00"
                          variant="filled"
                          id="ticketPrice"
                          name="ticketPrice"
                          value={formData.ticketPrice}
                          onChange={handleChange}
                          sx={{
                            "& .MuiInputBase-root": {
                              border: "1px solid #D5D9E2",
                              backgroundColor: "#fff",
                              borderRadius: "7px",
                            },
                            "& .MuiInputBase-root::before": { border: "none" },
                            "& .MuiInputBase-root:hover::before": { border: "none" },
                          }}
                        />
                      </FormControl>
                    </Box>
                  </Grid>
                )}
              </>
            )}

            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 4 }}>
              <Box>
                <Typography
                  component="label"
                  sx={{
                    fontWeight: "500",
                    fontSize: "14px",
                    mb: "10px",
                    display: "block",

                  }}
                  className="text-black"
                >
                  Event Category
                </Typography>

                <FormControl fullWidth>
                  <InputLabel id="event-category-label">Select</InputLabel>
                  {/* <Select
                    labelId="event-type-label"
                    id="event-type"
                    name="categoryid"
                    value={formData.categoryid || ""} // still keep id as value
                    onChange={handleChange}
                    renderValue={(selected) => {
                      if (!selected) return "Select"; // placeholder
                      const selectedCategory = category.find(cat => cat._id === selected);
                      console.log("Selected category details:", selectedCategory);
                      return selectedCategory ? selectedCategory.name : "";
                    }}
                    sx={{
                      "& fieldset": {
                        border: "1px solid #D5D9E2",
                        borderRadius: "7px",
                      },
                    }}
                  >
                    {isLoading ? (
                      <MenuItem disabled>Loading...</MenuItem>
                    ) : (
                      category.map((cat, index) => (
                        console.log("Category item:", cat),
                        
                        <MenuItem key={index} value={cat._id}>
                          {cat.name}
                        </MenuItem>
                      ))
                    )}
                  </Select> */}
                  <Select
                    labelId="event-category-label"
                    id="event-category"
                    name="categoryid"
                    value={formData.categoryid || ""}
                    onChange={handleChange}
                    renderValue={(selected) => {
                      if (!selected) return "Select"; // placeholder
                      const selectedCategory = category.find(cat => cat._id === selected);
                      //console.log("Selected category details:", selectedCategory);
                      return selectedCategory ? selectedCategory.name : "bnb";
                    }}
                    sx={{
                      "& fieldset": {
                        border: "1px solid #D5D9E2",
                        borderRadius: "7px",
                      },
                    }}
                  >
                    {isLoading ? (
                      <MenuItem disabled>Loading...</MenuItem>
                    ) : (
                      category.map((cat) => (
                        <MenuItem key={cat._id} value={cat._id}>
                          {cat.name}
                        </MenuItem>
                      ))
                    )}
                  </Select>

                </FormControl>
              </Box>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 4 }}>
              <Box>
                <Typography
                  component="label"
                  sx={{
                    fontWeight: "500",
                    fontSize: "14px",
                    mb: "10px",
                    display: "block",
                  }}
                  className="text-black"
                >
                  Event Venue
                </Typography>

                <FormControl fullWidth>
                  <InputLabel id="venue-label">Select</InputLabel>
                  <Select
                    labelId="venue-label"
                    id="event-venue"
                    name="venueid" // backend expects venueid
                    value={formData.venueid || ""}
                    onChange={handleVenueChange}
                    renderValue={(selected) => {
                      if (!selected) return "Select";
                      const selectedVenue = venue.find((v) => v.id === selected);

                      return selectedVenue
                        ? `${selectedVenue.address} (${selectedVenue.cityname}, ${selectedVenue.statename})`
                        : "";
                    }}
                    sx={{
                      "& fieldset": {
                        border: "1px solid #D5D9E2",
                        borderRadius: "7px",
                      },
                    }}
                  >
                    {isLoading ? (
                      <MenuItem disabled>Loading...</MenuItem>
                    ) : (
                      venue.map((v) => (
                        // console.log("Venue item:", v),
                        <MenuItem key={v.id} value={v.id}>
                          {v.address} ({v.cityname}, {v.statename})
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
              </Box>
            </Grid>


            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 4 }}>
              <Box>
                <Typography
                  component="label"
                  sx={{ fontWeight: "500", fontSize: "14px", mb: "10px", display: "block" }}
                  className="text-black"
                >
                  Event Country
                </Typography>

                <FormControl fullWidth>
                  <InputLabel id="country-label">Select</InputLabel>
                  <Select
                    labelId="country-label"
                    name="country"
                    value={formData.country || ""}   // store ISO code, not object
                    onChange={handleChange}
                    renderValue={(selected) => {
                      if (!selected) return "Select"; // placeholder
                      const selectedCountry = countries.find(c => c.isoCode === selected);
                      return selectedCountry ? selectedCountry.name : selected;
                    }}
                    sx={{
                      "& fieldset": {
                        border: "1px solid #D5D9E2",
                        borderRadius: "7px",
                      },
                    }}
                  >
                    {countries.map((c) => (
                      <MenuItem key={c.isoCode} value={c.isoCode}>
                        {c.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Grid>


            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 4 }}>
              <Box>
                <Typography
                  component="label"
                  sx={{
                    fontWeight: "500",
                    fontSize: "14px",
                    mb: "10px",
                    display: "block",
                  }}
                  className="text-black"
                >
                  Event State
                </Typography>

                <FormControl fullWidth>
                  <InputLabel id="state-label">Select</InputLabel>
                  <Select
                    labelId="state-label"
                    name="state"
                    value={formData.state || ""}
                    onChange={handleChange}
                    renderValue={(selected) => {
                      if (!selected) return "Select";
                      const selectedState = states.find((s) => s.isoCode === selected);
                      return selectedState ? selectedState.name : selected;
                    }}
                    sx={{
                      "& fieldset": {
                        border: "1px solid #D5D9E2",
                        borderRadius: "7px",
                      },
                    }}
                  >
                    {states.map((s) => (
                      <MenuItem key={s.isoCode} value={s.isoCode}>
                        {s.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Grid>

            {/* City */}
            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 4 }}>
              <Box>
                <Typography
                  component="label"
                  sx={{
                    fontWeight: "500",
                    fontSize: "14px",
                    mb: "10px",
                    display: "block",
                  }}
                  className="text-black"
                >
                  Event City
                </Typography>

                <FormControl fullWidth>
                  <InputLabel id="city-label">Select</InputLabel>
                  <Select
                    labelId="city-label"
                    name="city"
                    value={formData.city || ""}
                    onChange={handleChange}
                    renderValue={(selected) => selected || "Select"}
                    sx={{
                      "& fieldset": { border: "1px solid #D5D9E2", borderRadius: "7px" },
                    }}
                  >
                    {cities.map((city) => (
                      <MenuItem key={city.id} value={city.name}>
                        {city.name}
                      </MenuItem>
                    ))}
                  </Select>

                </FormControl>
              </Box>
            </Grid>


            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 4 }}>
              <Typography
                component="h5"
                sx={{
                  fontWeight: "500",
                  fontSize: "14px",
                  mb: "12px",
                }}
                className="text-black"
              >
                Event Start Date
              </Typography>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  sx={{
                    width: "100%",
                    "& fieldset": {
                      border: "1px solid rgba(0, 0, 0, 0.23)",
                      borderRadius: "7px",
                    },
                  }}
                  className="input-date-picker"

                  value={formData.startDate}
                  onChange={(newValue) => handleDateChange('startDate', newValue)}
                />
              </LocalizationProvider>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 4 }}>
              <Typography
                component="h5"
                sx={{
                  fontWeight: "500",
                  fontSize: "14px",
                  mb: "12px",
                }}
                className="text-black"
              >
                Event End Date
              </Typography>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={formData.endDate ? dayjs(formData.endDate) : null}
                  onChange={(newValue) => handleDateChange("endDate", newValue)}
                  sx={{
                    width: "100%",
                    "& fieldset": {
                      border: "1px solid rgba(0, 0, 0, 0.23)",
                      borderRadius: "7px",
                    },
                  }}
                  className="input-date-picker"
                />
              </LocalizationProvider>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 4 }}>
              <Box>
                <Typography
                  component="label"
                  sx={{
                    fontWeight: "500",
                    fontSize: "14px",
                    mb: "10px",
                    display: "block",
                  }}
                  className="text-black"
                >
                  Event Start Time
                </Typography>

                <TextField
                  id="start-time"
                  name="startTime"
                  type="time"
                  value={formData.startTime || ""}
                  onChange={handleChange}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    step: 300, // 5 min steps
                  }}
                  sx={{
                    "& fieldset": {
                      border: "1px solid #D5D9E2",
                      borderRadius: "7px",
                    },
                  }}
                />
              </Box>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 4 }}>
              <Box>
                <Typography
                  component="label"
                  sx={{
                    fontWeight: "500",
                    fontSize: "14px",
                    mb: "10px",
                    display: "block",
                  }}
                  className="text-black"
                >
                  Event End Time
                </Typography>

                <TextField
                  id="end-time"
                  name="endTime"
                  type="time"
                  value={formData.endTime || ""}
                  onChange={handleChange}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    step: 300, // 5 min steps
                  }}
                  sx={{
                    "& fieldset": {
                      border: "1px solid #D5D9E2",
                      borderRadius: "7px",
                    },
                  }}
                />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 4 }}>
              <Typography
                component="h5"
                sx={{
                  fontWeight: "500",
                  fontSize: "14px",
                  mb: "12px",
                }}
                className="text-black"
              >
                Registration Start Date
              </Typography>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                {/* <DatePicker
                  value={formData.registrationStart}
                  onChange={(newValue) => handleDateChange("registrationStart", newValue)}

                  sx={{
                    width: "100%",
                    "& fieldset": {
                      border: "1px solid rgba(0, 0, 0, 0.23)",
                      borderRadius: "7px",
                    },
                  }}
                  className="input-date-picker"
                /> */}
                <DatePicker
                  value={formData.registrationStart ? dayjs(formData.registrationStart) : null}
                  onChange={(newValue) => handleDateChange("registrationStart", newValue)}
                  sx={{
                    width: "100%",
                    "& fieldset": {
                      border: "1px solid rgba(0, 0, 0, 0.23)",
                      borderRadius: "7px",
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 4 }}>
              <Typography
                component="h5"
                sx={{
                  fontWeight: "500",
                  fontSize: "14px",
                  mb: "12px",
                }}
                className="text-black"
              >
                Registration End Date
              </Typography>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                {/* <DatePicker
                  value={formData.registrationEnd}
                  onChange={(newValue) => handleDateChange("registrationEnd", newValue)}

                  sx={{
                    width: "100%",
                    "& fieldset": {
                      border: "1px solid rgba(0, 0, 0, 0.23)",
                      borderRadius: "7px",
                    },
                  }}
                  className="input-date-picker"
                /> */}
                <DatePicker
                  value={formData.registrationEnd ? dayjs(formData.registrationEnd) : null}
                  onChange={(newValue) => handleDateChange("registrationEnd", newValue)}
                  sx={{
                    width: "100%",
                    "& fieldset": {
                      border: "1px solid rgba(0, 0, 0, 0.23)",
                      borderRadius: "7px",
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 4 }}>
              <Box>
                <FormControl fullWidth>
                  <Typography
                    component="label"
                    sx={{
                      fontWeight: "500",
                      fontSize: "14px",
                      mb: "10px",
                      display: "block",
                    }}
                    className="text-black"
                  >
                    Event Organizers
                  </Typography>

                  <TextField
                    label="Enter event organizers name"
                    placeholder="E.g. Hand Watch"
                    variant="filled"
                    id="organizers"
                    name="organizers"
                    value={formData.organizers}
                    onChange={handleChange}

                    // required
                    sx={{
                      "& .MuiInputBase-root": {
                        border: "1px solid #D5D9E2",
                        backgroundColor: "#fff",
                        borderRadius: "7px",
                      },
                      "& .MuiInputBase-root::before": {
                        border: "none",
                      },
                      "& .MuiInputBase-root:hover::before": {
                        border: "none",
                      },
                      "& .MuiInputBase-root:hover:hover:not(.Mui-disabled, .Mui-error)::before":
                      {
                        border: "none",
                      },
                    }}
                  />
                </FormControl>
              </Box>
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 4 }}>
              <Box>
                <FormControl fullWidth>
                  <Typography
                    component="label"
                    sx={{
                      fontWeight: "500",
                      fontSize: "14px",
                      mb: "10px",
                      display: "block",
                    }}
                    className="text-black"
                  >
                    Event Sponsors
                  </Typography>

                  <TextField
                    label="Enter event sponsors name"
                    placeholder="E.g. Hand Watch"
                    variant="filled"
                    id="sponsors"
                    name="sponsors"
                    value={formData.sponsors}
                    onChange={handleChange}
                    // required
                    sx={{
                      "& .MuiInputBase-root": {
                        border: "1px solid #D5D9E2",
                        backgroundColor: "#fff",
                        borderRadius: "7px",
                      },
                      "& .MuiInputBase-root::before": {
                        border: "none",
                      },
                      "& .MuiInputBase-root:hover::before": {
                        border: "none",
                      },
                      "& .MuiInputBase-root:hover:hover:not(.Mui-disabled, .Mui-error)::before":
                      {
                        border: "none",
                      },
                    }}
                  />
                </FormControl>
              </Box>
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 4 }}>
              <Box>
                <FormControl fullWidth>
                  <Typography
                    component="label"
                    sx={{
                      fontWeight: "500",
                      fontSize: "14px",
                      mb: "10px",
                      display: "block",
                    }}
                    className="text-black"
                  >
                    Max Booking
                  </Typography>

                  <TextField
                    label="Enter max booking"
                    placeholder="E.g. Hand Watch"
                    variant="filled"
                    id="maxbooking"
                    name="maxbooking"
                    type="number"
                    value={formData.maxbooking}
                    onChange={handleChange}
                    // required
                    sx={{
                      "& .MuiInputBase-root": {
                        border: "1px solid #D5D9E2",
                        backgroundColor: "#fff",
                        borderRadius: "7px",
                      },
                      "& .MuiInputBase-root::before": {
                        border: "none",
                      },
                      "& .MuiInputBase-root:hover::before": {
                        border: "none",
                      },
                      "& .MuiInputBase-root:hover:hover:not(.Mui-disabled, .Mui-error)::before":
                      {
                        border: "none",
                      },
                    }}
                  />
                </FormControl>
              </Box>
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
              <Box>
                <Typography
                  component="label"
                  sx={{
                    fontWeight: "500",
                    fontSize: "14px",
                    mb: "10px",
                    display: "block",
                  }}
                  className="text-black"
                >
                  Event description
                </Typography>

                <CustomEditor
                  value={formData.description}
                  onChange={(content) => setFormData((prev) => ({
                    ...prev,
                    description: content
                  }))}
                />
              </Box>
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
              <Typography
                component="h5"
                sx={{
                  fontWeight: "500",
                  fontSize: "14px",
                  mb: "12px",
                }}
                className="text-black"
              >
                Event Image
              </Typography>

              <FileUpload
                onFileSelect={(file) =>
                  setFormData((prev) => ({ ...prev, eventImage: file }))
                }
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: { xs: "10px", sm: "20px" },
                }}
              >
                {/* <Button
                  type="submit"
                  variant="contained"
                  color="error"
                  sx={{
                    textTransform: "capitalize",
                    borderRadius: "6px",
                    fontWeight: "500",
                    fontSize: { xs: "13px", sm: "16px" },
                    padding: { xs: "10px 20px", sm: "10px 24px" },
                    color: "#fff !important",
                    boxShadow: "none",
                  }}
                >
                  Cancel
                </Button>

                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    textTransform: "capitalize",
                    borderRadius: "6px",
                    fontWeight: "500",
                    fontSize: { xs: "13px", sm: "16px" },
                    padding: { xs: "10px 20px", sm: "10px 24px" },
                    color: "#fff !important",
                    boxShadow: "none",
                  }}
                >
                  <i className="material-symbols-outlined">add</i>{" "}
                  Create/Publish
                </Button> */}

                <Button
                  variant="outlined"
                  onClick={(e) => handleSubmit(e, "draft")}
                >
                  Save as Draft
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={(e) => handleSubmit(e, "submitted")}
                >
                  Submit for Approval
                </Button>

              </Box>
            </Grid>
          </Grid>
        </Card>
      </Box>
    </>
  );
};

export default EditAnEventForm;
